import React, { useEffect, useState } from "react";
import { fetchPublicConfig } from "../lib/api";

// Renders either Calendly iframe (if CALENDLY_URL ends with calendly.com) or generic embed (cal.com)
// Uses hardcoded fallback so Calendly always works — even if backend env var isn't set.
const CALENDLY_FALLBACK = "https://calendly.com/good-life-impuls/30min";

const CalendlyEmbed = () => {
  const [url, setUrl] = useState(CALENDLY_FALLBACK);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchPublicConfig().then((c) => {
      setUrl(c.calendly_url || CALENDLY_FALLBACK);
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  if (!loaded) return null;

  return (
    <div className="rounded-2xl overflow-hidden border border-white/10 bg-white" data-testid="calendly-embed">
      <iframe
        src={url}
        width="100%"
        height="680"
        frameBorder="0"
        title="Termin buchen"
        style={{ border: 0 }}
      ></iframe>
    </div>
  );
};

export default CalendlyEmbed;
